// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import { initialState } from './initialState'

import {
  ASSIGN_USER_DATA,
} from './types'

const user = (state = initialState, action) => {
  switch (action.type) {
    case ASSIGN_USER_DATA :
      return state.merge(
        fromJS(action.userData)
      )

    default :
      return state
  }
}

export default user
